import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import settingDrawer from './it-IT/settingDrawer';
export default _objectSpread({}, settingDrawer);